import theme from '../../constants/theme';
export const Style = ({
    title: {
        color: 'white',
        fontSize: 12
    }
});